import * as React from 'react';
export var Container = function (_a) {
    var children = _a.children, _b = _a.mode, mode = _b === void 0 ? 'light' : _b;
    return (React.createElement("section", { className: "".concat(mode, "-background") },
        React.createElement("div", { className: "container" }, children)));
};
//# sourceMappingURL=index.js.map